document.addEventListener('DOMContentLoaded', function() {
    var details = document.querySelectorAll('.accordion .tmp__accordion_details')
    for (var index = 0; index < details.length; index++) {
        details[index].addEventListener("click", function () {
            if (this.getAttribute('open') == null) { 
                console.log('')
                this.children[0].children[1].classList.add('open')
            } else {
                this.children[0].children[1].classList.remove('open')
            }
        })
    }
    // details.forEach(function(detail) {
    //     detail.addEventListener('click', function() {
    //         if(detail != null) { 
    //             console.log(detail)
    //             console.log('zzz')
    //         }
    //     })
    // })
})